<template>
  <div id="app">
    <router-view v-if="isRouterAlive && !$route.meta.keepAlive" />
    <keep-alive>
      <router-view v-if="isRouterAlive && $route.meta.keepAlive" />
    </keep-alive>
  </div>
</template>

<script>
import { syncLocaleFromUrl, onLocaleChange } from '@/utils/lang'

export default {
  name: 'App',
  provide (){
     return {
       reload:this.reload
     }
  },
  data(){
    return {
       isRouterAlive:true
    }
  },
  watch: {
    '$route.query.lang' () {
      syncLocaleFromUrl(this.$i18n, this.$route.query)
    }
  },
  created () {
    this._offLocaleChange = onLocaleChange(() => {
      this.reload()
    })
    syncLocaleFromUrl(this.$i18n, this.$route.query)
    this.getUrl()
  },
  mounted () {
    this._syncLangFromUrl = () => {
      syncLocaleFromUrl(this.$i18n, this.$route.query)
    }
    window.addEventListener('popstate', this._syncLangFromUrl)
  },
  beforeDestroy () {
    if (this._offLocaleChange) {
      this._offLocaleChange()
    }
    if (this._syncLangFromUrl) {
      window.removeEventListener('popstate', this._syncLangFromUrl)
    }
  },
  methods:{
    //获取上传地址
    async getUrl () {
      await this.$http.get('/tutor/api/uploadDomail').then(res => {
        sessionStorage.setItem('uploadUrl', res.data.data.upload_domin)
      })
    },
    reload (){
       this.isRouterAlive = false
       this.$nextTick(function(){
          this.isRouterAlive = true
       })
    }
  },
}
</script>

<style lang="less">
html,body{
  width:100%;
  height:100%;

  background: #ffffff;
}
#app {
  color: #353643;
  font-family: Sofia Pro-Regular;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  background: #ffffff;
  overflow:initial;
  height: 100%;
}
*{
  margin:0;
  padding:0;
}
body{
  margin: 0 !important;
  font-family: Sofia Pro-Regular;
}
a{
  text-decoration: none;
}
ul,li{
  list-style:none;
}
/* element-ui 下拉框在ios上 点击两次才能选中 */
.el-scrollbar {
    > .el-scrollbar__bar {
        opacity: 1 !important;
    }
}
</style>



// WEBPACK FOOTER //
// src/App.vue